import * as api from "./api";
import * as docPartnerApi from "features/document/edit/partners/api";
import { sendHttpCommandAndWaitForEvent, sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";

export function loadActivityFieldsTypes(search) {
  return () => api.getActivityFieldsTypes(search);
}

export function loadPartnerActivityFields(documentId, siteId, partnerId) {
  return async (dispatch, getState) => {
    const activities = getState().currentOffer.clientActivityFieldsData[partnerId];
    let shouldCallApi = !activities || (!activities.isLoaded && !activities.loading);

    if (!shouldCallApi) {
      return;
    }
    dispatch({ type: actionTypes.LOAD_ACTIVITY_FIELDS_STARTED, key: partnerId });
    try {
      const partnerActivityFields = await dispatch(
        sendHttpRequest(docPartnerApi.getActivityFields(documentId, siteId, partnerId))
      );

      dispatch({
        type: actionTypes.LOAD_ACTIVITY_FIELDS_SUCCEEDED,
        payload: { partnerActivityFields }
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
export function savePartnerActivityFields(documentId, siteId, partnerId, activityFields, callbackFn = () => {}) {
  return async dispatch => {
    try {
      dispatch({
        type: actionTypes.UPDATE_ACTIVITY_FIELDS_STARTED,
        payload: activityFields,
        documentId: documentId,
        siteId: siteId,
        partnerId: partnerId
      });
      let event;
      event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          docPartnerApi.saveActivityFields(documentId, siteId, partnerId, activityFields),
          "saveActivityFields",
          [eventTypes.ACTIVITY_FIELDS_UPDATED]
        )
      );

      if (event.ok) {
        dispatch({
          type: actionTypes.UPDATE_ACTIVITY_FIELDS_SUCCEEDED,
          activityFields: event.eventBody.activityFields,
          partnerId: partnerId
        });
        callbackFn();
      } else {
        dispatch({ type: actionTypes.UPDATE_ACTIVITY_FIELDS_FAILED, payload: { activityFields, error: event } });
      }

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
